import { __assign } from "tslib";
import React from 'react';
var ImageRenderer = function (props) {
    if (typeof ImageRenderer.customImageRenderer === 'function') {
        return ImageRenderer.customImageRenderer(props);
    }
    else if (typeof props.src === 'string') {
        return React.createElement("img", __assign({ alt: props.alt }, props));
    }
    else if (typeof props.src === 'object') {
        return (React.createElement("picture", { id: "multi_picture_" + props.id, key: "multi_picture_" + props.id },
            props.src.map(function (src) { return (React.createElement("source", { srcSet: src.dpr || src.url, type: "image/" + src.type })); }),
            React.createElement("img", __assign({ alt: props.alt }, props, { src: props.src[0].url }))));
    }
    else {
        return null;
    }
};
export default ImageRenderer;
//# sourceMappingURL=imageRenderer.js.map